// extracted by mini-css-extract-plugin
module.exports = {"content":"layout-module--content--3nIku","pageWrapper":"layout-module--page-wrapper--31DW9","link":"layout-module--link--3HFTi"};